<template>
  <div id="faq_detail">
    <!-- <div class="top_title fixed">帮助中心</div> -->
    <div class="faq_content">
      <div class="chat left">
        <p class="chat_box">Q：{{ title }}</p>
      </div>
      <div class="chat right">
        <div class="chat_box">
            <span class="prefix">A：</span>
            <div v-html="content"></div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      content: "",
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  mounted() {
    this.getFaqDetail();
  },
  methods: {
    getFaqDetail() {
      this.$Ajax("faq/faq-detail", { id: this.id }).then(rs => {
        if (rs.code == 200) {
          this.title = rs.data.title;
          this.content = rs.data.content;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
#faq_detail {
  padding-top: 1rem;
  .faq_content {
    padding: 1.2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    &.qq {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.7rem;
      font-weight: 700;
      min-height: calc(var(--vh,1vh)*100 - 24rem);
      background-color: unset;
    }
  }
  .chat {
    display: flex;
    margin-bottom: 1.4rem;
    .chat_box {
      padding: 0.6rem 1rem;
      background-color: #e6ebff;
      word-break: break-all;
      border-radius: 0.6rem;
      border: 0.15rem solid var(--placeholder);
      position: relative;
      display: flex;
      align-items: flex-start;
      /deep/img {
        max-width: 100%;
        margin: 1rem auto;
      }
      &::after {
        content: "";
        width: 0.95rem;
        height: 0.6rem;
        position: absolute;
      }
      p,span,div {
        background-color: transparent !important;
      }
    }
    &.left {
      justify-content: flex-start;
      .chat_box {
        &::after {
          background: url(../../assets/bx/chat_left.png) no-repeat 0 0 / 100% 100%;
          bottom: -0.6rem;
          left: 1rem;
        }
      }
    }
    &.right {
      justify-content: flex-end;
      .chat_box {
        background-color: var(--chooseBg);
        border-color: #04b4fd;
        .prefix {
            transform: translateY(-0.2rem);
        }
        &::after {
          background: url(../../assets/bx/chat_right.png) no-repeat 0 0 / 100% 100%;
          bottom: -0.6rem;
          right: 1rem;
        }
      }
    }
  }
}
</style>
